import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './AffiliatePitch.module.css';

export default function AffiliatePitch() {
  const [copied, setCopied] = useState<string | false>(false);
  const [tweetsContent, setTweetsContent] = useState<string>('');

  const longPost = `🚀 EXCLUSIVE: Become a MyPeopleDatabase Founders Affiliate & Earn 30% Commission All Year!

Are you a consultant, coach, or business owner who works with companies on people management?

I've got an incredible opportunity for you! 💰

MyPeopleDatabase just launched their Founders Affiliate Program and it's absolutely game-changing:

🎯 What You'll Earn:
✅ 30% commission on ALL referrals (not just first year!)
✅ 30% on renewals too (usually only 10%)
✅ Valid for the entire year of 2026
✅ Priority support & exclusive resources

💡 Why This Works:
MyPeopleDatabase solves a REAL problem every business faces - managing employee data, tracking performance, and staying compliant. It's not a hard sell because companies actually NEED this.

Perfect for:
- HR Consultants
- Business Coaches
- Management Consultants
- Content Creators in the business space
- Anyone with a business audience

🔥 The Numbers:
- Desktop App: $49.99 one-time or $39.99/year subscription
- Your cut: 30% commission on all sales
- 60-day cookie tracking
- Monthly payouts
- No minimum threshold for Founders Affiliates

🎁 What You Get:
- Professional marketing materials
- Product demos & training
- Dedicated affiliate dashboard
- Real-time tracking & analytics
- Direct support line

This isn't your typical affiliate program. MyPeopleDatabase is solving a genuine pain point that every growing business faces. When you recommend it, you're actually helping companies get organized and compliant - it's a win-win-win.

The Founders rate of 30% is LIMITED and honestly, I don't know how long they'll keep it this high.

Ready to start earning?

👉 Apply here: https://mypeopledatabase.com/affiliate-program

Questions? Drop them below! I'm happy to share more about why I'm excited about this opportunity.

P.S. - Even if you're not ready to actively promote yet, I'd grab your Founders Affiliate spot now to lock in that 30% rate. You can always start promoting later!

#Affiliate #PassiveIncome #BusinessOpportunity #HRTech #Consulting`;

  const shortPost = `🚨 FOUNDERS AFFILIATE ALERT 🚨

MyPeopleDatabase is offering 30% commission for ALL of 2026 to their first affiliates!

Most affiliate programs give you 5-10%. This is 30% on a product businesses actually NEED.

✅ $49.99 one-time or $39.99/year subscriptions
✅ 30% on renewals too
✅ 60-day tracking
✅ Monthly payouts

Perfect for consultants, coaches, and anyone in the business space.

Limited spots available 👉 https://mypeopledatabase.com/affiliate-program

#AffiliateMarketing #PassiveIncome #BusinessOpportunity`;

  useEffect(() => {
    // Fetch tweets.txt content
    fetch('/docs/tweets.txt')
      .then(response => response.text())
      .then(text => setTweetsContent(text))
      .catch(error => console.error('Error loading tweets:', error));
  }, []);

  const copyToClipboard = (text: string, type: string) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(type);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Link to="/affiliate-program" className={styles.backLink}>
          ← Back to Affiliate Program
        </Link>
        <h1 className={styles.title}>Affiliate Pitch Templates</h1>
        <p className={styles.subtitle}>
          Ready-to-use social media posts to help you promote the MyPeopleDatabase Founders
          Affiliate Program
        </p>
      </div>

      <div className={styles.content}>
        <div className={styles.introSection}>
          <div className={styles.highlight}>
            <h2>🚀 Promote the Founders Affiliate Program</h2>
            <p>
              Use these proven templates to share the MyPeopleDatabase Founders Affiliate
              opportunity with your network. Just copy, customize with your voice, and post!
            </p>
          </div>
        </div>

        <div className={styles.templatesSection}>
          <div className={styles.template}>
            <div className={styles.templateHeader}>
              <h3>📝 Long-Form Post (Blog/LinkedIn)</h3>
              <p>Perfect for detailed posts, blog articles, or LinkedIn content</p>
            </div>
            <div className={styles.templateContent}>
              <pre className={styles.postText}>{longPost}</pre>
            </div>
            <div className={styles.templateActions}>
              <button
                onClick={() => copyToClipboard(longPost, 'long')}
                className={styles.copyButton}
              >
                {copied === 'long' ? '✅ Copied!' : '📋 Copy Post'}
              </button>
              <span className={styles.wordCount}>~400 words</span>
            </div>
          </div>

          <div className={styles.template}>
            <div className={styles.templateHeader}>
              <h3>📱 Short-Form Post (Twitter/Instagram)</h3>
              <p>Concise version for social media platforms with character limits</p>
            </div>
            <div className={styles.templateContent}>
              <pre className={styles.postText}>{shortPost}</pre>
            </div>
            <div className={styles.templateActions}>
              <button
                onClick={() => copyToClipboard(shortPost, 'short')}
                className={styles.copyButton}
              >
                {copied === 'short' ? '✅ Copied!' : '📋 Copy Post'}
              </button>
              <span className={styles.wordCount}>~100 words</span>
            </div>
          </div>
        </div>

        <div className={styles.tipsSection}>
          <h2>💡 Customization Tips</h2>
          <div className={styles.tips}>
            <div className={styles.tip}>
              <h4>🎯 Make it Personal</h4>
              <p>Add your own introduction and explain why YOU'RE excited about this opportunity</p>
            </div>
            <div className={styles.tip}>
              <h4>🔗 Update Links</h4>
              <p>
                Replace the generic affiliate link with your personal tracking link once you're
                approved
              </p>
            </div>
            <div className={styles.tip}>
              <h4>📸 Add Visuals</h4>
              <p>
                Include screenshots of the affiliate dashboard or commission examples for more
                engagement
              </p>
            </div>
            <div className={styles.tip}>
              <h4>💬 Engage</h4>
              <p>Respond to comments and questions to build trust and provide more information</p>
            </div>
          </div>
        </div>

        {tweetsContent && (
          <div className={styles.tweetsSection}>
            <h2>📱 Social Media Content Ideas</h2>
            <p className={styles.tweetsIntro}>
              Here are ready-to-use tweet ideas and social media posts you can adapt for promoting MyPeopleDatabase:
            </p>
            <div className={styles.tweetsContainer}>
              <pre className={styles.tweetsText}>{tweetsContent}</pre>
            </div>
          </div>
        )}

        <div className={styles.ctaSection}>
          <div className={styles.ctaBox}>
            <h2>Ready to Start Earning?</h2>
            <p>
              Join the Founders Affiliate Program and lock in your 30% commission rate for all of
              2026!
            </p>
            <div className={styles.ctaButtons}>
              <Link to="/signup" state={{ fromAffiliate: true }} className={styles.primaryButton}>
                Apply Now
              </Link>
              <Link to="/affiliate-program" className={styles.secondaryButton}>
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
